var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M21.005 5.394l-.4-.4a3.023 3.023 0 0 0-4.271 0l-.612.611L4.459 16.868a.415.415 0 0 0-.098.152l-2.229 6.354a.386.386 0 0 0 .493.492l1.278-.449a.386.386 0 1 0-.256-.729l-.52.183 1.76-5.016 3.256 3.256-4.496 1.534a.386.386 0 1 0 .256.729l5.075-1.737a.385.385 0 0 0 .14-.087l11.274-11.273.613-.613a3.023 3.023 0 0 0 0-4.27zM8.857 20.72L5.278 17.14 15.995 6.425l3.578 3.578L8.857 20.72zM20.458 9.118l-.339.339-1.789-1.79-1.789-1.788.339-.34a2.25 2.25 0 0 1 3.178 0l.4.401a2.25 2.25 0 0 1 0 3.178z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7da4ebc707957ef97bc5d50728f6fa07.svg";
export { ForwardRef as ReactComponent };